import {
  CLEAR_BADGE_STATE,
  FETCH_BADGE_REQUEST,
  RECEIVE_BADGE_TEMPLATE,
  RECEIVE_BADGE_TEMPLATE_ERROR,
  RECEIVE_ISSUED_BADGE,
  RECEIVE_ISSUED_BADGE_ERROR,
} from 'redux/constants/ActionTypes'

import { createApiAction } from './ApiActions'

// API actions
export const fetchIssuedBadge = (params) => {
  const { locale, ...endpointParams } = params
  const endpoint = new URL(
    `${process.env.REACT_APP_BADGE_SERVICE_API_URL}/api/v1/${locale}/issued_badges/single_badge`
  )
  for (const k in endpointParams) {
    if (endpointParams[k]) {
      endpoint.searchParams.append(k, endpointParams[k])
    }
  }
  return createApiAction({
    endpoint: endpoint.href,
    types: [
      FETCH_BADGE_REQUEST,
      RECEIVE_ISSUED_BADGE,
      RECEIVE_ISSUED_BADGE_ERROR,
    ],
    normalizePath: 'data',
    actions: {
      RECEIVE_ISSUED_BADGE_ERROR: {
        action: fetchBadgeTemplate(params),
      },
    },
  })
}

export const fetchBadgeTemplate = ({ badge_template_id, locale }) => {
  const endpoint = new URL(
    `${process.env.REACT_APP_BADGE_SERVICE_API_URL}/api/v1/${locale}/badge_template/${badge_template_id}`
  )
  return createApiAction({
    endpoint: endpoint.href,
    types: [
      FETCH_BADGE_REQUEST,
      RECEIVE_BADGE_TEMPLATE,
      RECEIVE_BADGE_TEMPLATE_ERROR,
    ],
    normalizePath: 'data',
  })
}

// Standard actions
export const clearBadgeState = {
  type: CLEAR_BADGE_STATE,
}
